// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1H5lY","amount":"Amount_amount__2_F1I","tip":"Amount_tip__3C3_1","tipHeader":"Amount_tipHeader__2i0ln","tipsWrap":"Amount_tipsWrap__2q_aZ"};